import { Injectable } from '@angular/core';
import { Result } from 'neverthrow';
import { PublicationFileLocalRepositoryService } from 'src/app/module/actions/data/repository/publication-file-local-repository.service';
import { PublicationFileRemoteRepositoryService } from 'src/app/module/actions/data/repository/publication-file-remote-repository.service';
import { z } from 'zod';
import { HttpErrorResponse } from '@angular/common/http';

export const PublicationFileGetByDocumentIdInputDTOSchema = z.object({
  datePublication: z.string(),
  documentId: z.number(),
  processId: z.number(),
});
export type PublicationFileGetByDocumentIdInput = z.infer<typeof PublicationFileGetByDocumentIdInputDTOSchema>

export const PublicationFileGetByDocumentIdOutPutDTOSchema = z.object({
  id: z.number().optional(),
  file: z.string(),
  extension: z.string(),
  name: z.string(),
  path: z.string(),
  documentId: z.number(),
  datePublication: z.string(),
}).array();
export type PublicationFileGetByDocumentIdOutPut = z.infer<typeof PublicationFileGetByDocumentIdOutPutDTOSchema>

export interface IPublicationFilesSyncResult {
  added: PublicationFileGetByDocumentIdOutPut;
  updated: PublicationFileGetByDocumentIdOutPut;
  remove: PublicationFileGetByDocumentIdOutPut;
}

@Injectable({
  providedIn: 'root'
})
export class PublicationFileGetByDocumentIdService {

  constructor(
    private local: PublicationFileLocalRepositoryService,
    private remote: PublicationFileRemoteRepositoryService
  ) { }

  async execute(input: PublicationFileGetByDocumentIdInput): Promise<Result<IPublicationFilesSyncResult, HttpErrorResponse>> {
    var httpResult = await this.remote.FileListByDocumentId(input);

    if(httpResult.isOk()) {
      var localResult = await this.local.find({documentId: input.documentId});
      if(localResult.isOk()) {
        const serverFiles = httpResult.value.data

        const added = [];
        const updated = [];
        const remove = [];

        for (const localItem of localResult.value) {
          if (localItem.datePublication !== input.datePublication!) {
            localItem.datePublication = input.datePublication;
            this.local.update(localItem.id, localItem);
          }
        }

        for (const file of serverFiles) {
          const findLocally = await this.local.findOne({ name: file.name });

          if (findLocally.isOk() && findLocally.value == null) {
            added.push({
              ...file,
              documentId: input.documentId!,
              datePublication: input.datePublication,
            });

            const start = performance.now();
            await this.local.insert({
              ...file,
              documentId: input.documentId!,
              datePublication: input.datePublication,
            }).then(() => {
              const end = performance.now();
              //console.log(`Insert duration for file "${file.name}": ${(end - start).toFixed(2)} ms`);
            });
          }
        }

        for (const localFile of localResult.value) {
          const found = httpResult.value.data.filter((e) => e.name === localFile.name);
          if (found.length === 0 && localFile.name) {
            remove.push(localFile);
            await this.local.delete(localFile.id);
          }
        }

        return httpResult.map(() =>({
          added,
          updated,
          remove
        }))
      }
    }

    return httpResult.map(() =>({
      added: [],
      updated: [],
      remove: []
    }));
  }
}
